import { createTerms } from './createTerms';
import { mergeTermsValue } from './mergeTermsValue';
import { IJsonQueryTerms } from '../../types/jsonQuery/term';

export function mergeTerms<T>({
  jsonQueryPart,
  newJsonQueryPart,
}: {
  jsonQueryPart: IJsonQueryTerms<T>;
  newJsonQueryPart: IJsonQueryTerms<T>;
}) {
  const newTerms = newJsonQueryPart?.value || [];
  const oldTerms = jsonQueryPart?.value || [];

  const value = mergeTermsValue({ oldTerms, newTerms });

  // Для пустого массива весь фильтр заменяется на null
  if (value.length === 0) {
    return null;
  }

  return createTerms(value);
}
